var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-right"},[_c('span',{staticClass:"caption"},[_vm._v(" Event connection status: "),_c('v-avatar',{staticClass:"mb-1",attrs:{"size":"12","color":_vm.states[_vm.readyState].color}}),_vm._v(" "+_vm._s(_vm.states[_vm.readyState].text)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }